module.exports = __webpack_public_path__ + "img/成果展示banner.948770c9.png";